import { supabase } from "./client";
import { withRequestDeadline } from "./requestDeadline";

export const COMMISSION_TERMS_UPDATED = "mozzoapp:commission-terms-updated";
export const COMMISSION_DEBT_BLOCK_MESSAGE = "Este local no puede recibir pedidos nuevos por comisiones vencidas. Los pedidos en curso pueden completarse.";

export const hasAdditionalOrderItems = (previous = [], next = []) => {
  const totals = (items) => items.reduce((result, item) => {
    const key = item.productId || item.sourceProductId || item.productName || item.sourceProductName || item.id || item.name || item.nombre;
    const quantity = /^[0-9]+([.][0-9]+)?$/.test(String(item.quantity ?? "")) ? Number(item.quantity) : 1;
    result.set(key, (result.get(key) || 0) + quantity);
    return result;
  }, new Map());
  const before = totals(previous);
  return [...totals(next)].some(([key, quantity]) => quantity > (before.get(key) || 0));
};

const call = async (name, params) => {
  if (!supabase) throw new Error("No se pudo verificar el estado de las comisiones.");
  const { data, error } = await withRequestDeadline(
    (signal) => supabase.rpc(name, params).abortSignal(signal),
    { timeoutMs: 8000, message: "No se pudo verificar el estado de las comisiones. Reintenta." }
  );
  if (error) throw new Error(error.message || "No se pudo consultar el estado de las comisiones.");
  return data;
};

export const getCommissionDebtTerms = (branchId) =>
  call("get_branch_commission_debt_status", { p_branch_id: branchId });

export const assertAcceptingNewOrders = async (branchId) => {
  const status = await call("get_public_branch_order_acceptance", { p_branch_id: branchId });
  if (status?.acceptingNewOrders !== true) throw new Error(COMMISSION_DEBT_BLOCK_MESSAGE);
  return status;
};

export const confirmCommissionTransfer = async ({ branchId, paymentId, amount, reference, receivedAt }) => {
  const status = await call("confirm_branch_commission_direct_payment", {
    p_branch_id: branchId, p_payment_id: paymentId, p_amount: amount,
    p_transfer_reference: reference, p_received_at: receivedAt,
  });
  window.dispatchEvent(new CustomEvent(COMMISSION_TERMS_UPDATED, { detail: { branchId } }));
  return status;
};
